import { TChatbotFiltersModalSetManifestPayload, EChatbotFiltersModalActionTypes } from './types';
import { EManifestStatus } from '../../types/chatbotFiltersModal';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Открыть окно действия с фильтрами чатбота
 */
export const openChatbotFiltersModal = actionGenerator<EChatbotFiltersModalActionTypes.Open>(
  EChatbotFiltersModalActionTypes.Open,
);

/**
 * Закрыть окно действия с фильтрами чатбота
 */
export const closeChatbotFiltersModal = actionGenerator<EChatbotFiltersModalActionTypes.Close, void>(
  EChatbotFiltersModalActionTypes.Close,
);

/**
 * Установить манифест фильтров микрофронта
 */
export const setManifestForChatbotFiltersModal = actionGenerator<
  EChatbotFiltersModalActionTypes.SetManifest,
  TChatbotFiltersModalSetManifestPayload
>(EChatbotFiltersModalActionTypes.SetManifest);

/**
 * Установить статус загрузки манифеста фильтров микрофронта
 */
export const setManifestStatusForChatbotFiltersModal = actionGenerator<
  EChatbotFiltersModalActionTypes.SetManifestStatus,
  EManifestStatus
>(EChatbotFiltersModalActionTypes.SetManifestStatus);

/**
 * Установить статус применения фильтров
 */
export const setFiltersLoading = actionGenerator<EChatbotFiltersModalActionTypes.SetFiltersLoading, boolean>(
  EChatbotFiltersModalActionTypes.SetFiltersLoading,
);
